import { DEFAULT_FORMS_BASE_URL } from '@jfh/intake-shared';

// Per-deployment origins. Production builds use the live defaults; staging
// builds (`vite build --mode staging`, see vite.config.ts) pin every link to
// the staging Worker and forms, so nothing in the staging admin can open or
// hand out a LIVE form or webhook.

/** Forms site forced by a staging build; undefined in production. */
export const STAGING_FORMS_BASE_URL: string | undefined = import.meta.env.VITE_FORMS_BASE_URL;

/** Forms base shown before (or instead of) the saved setting loads. */
export const INITIAL_FORMS_BASE_URL = STAGING_FORMS_BASE_URL ?? DEFAULT_FORMS_BASE_URL;

/** The Worker's public origin (shown as the Power Automate callback). */
export const API_ORIGIN: string =
  import.meta.env.VITE_API_ORIGIN ?? 'https://jfh-intake-api.jfhhorticultural.workers.dev';
